import { assign } from 'xstate5';

import { downgradeExtrasToIncluded as downgradeExtras } from '../../helpers';
import { type CustomizationMachineAction } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * After an included modification is removed, swaps any active extras
 * modification to its included counterpart if the included group has room.
 */
export const downgradeExtrasToIncluded: CustomizationMachineAction = assign((args) => {
  const { context } = args;

  const {
    includedModificationsMap,
    includedModifierGroupsByExtrasName,
    modificationLimits,
    modifications,
    isUpsellPricingEnabled,
  } = context;

  if (!isUpsellPricingEnabled || !modifications) return {};

  const updatedActives = downgradeExtras({
    activeModifications: modifications.active,
    includedModificationsMap,
    includedModifierGroupsByExtrasName,
    modificationLimits,
  });

  if (updatedActives === modifications.active) return {};

  return { modifications: { ...modifications, active: updatedActives } };
});
